// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PwvH","label":"styles_label__azVG_"};